/* eslint-disable */
import { DateGraphQL } from "scalarLink";
import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
import gql from "graphql-tag";
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `Byte` scalar type represents non-fractional whole numeric values. Byte can represent values between 0 and 255. */
  Byte: any;
  /** The `Date` scalar represents an ISO-8601 compliant date type. */
  Date: DateGraphQL;
  /** The built-in `Decimal` scalar type. */
  Decimal: number;
};

export type AdminAttachment = {
  __typename?: "AdminAttachment";
  id: Scalars["Int"];
  filename: Scalars["String"];
  data: Array<Scalars["Byte"]>;
  applicationId: Scalars["Int"];
  addedByUserId: Scalars["String"];
  contentType: Scalars["String"];
};

export type AdminUser = {
  __typename?: "AdminUser";
  id: Scalars["String"];
  fullName: Scalars["String"];
};

export type AdverseJudgementFile = {
  __typename?: "AdverseJudgementFile";
  claimId: Scalars["Int"];
  fileStorageId: Scalars["Int"];
};

export enum ApplicationStatus {
  UNSAVED_APPLICATION = "UNSAVED_APPLICATION",
  SAVED_QUOTE = "SAVED_QUOTE",
  EXPIRED_QUOTE = "EXPIRED_QUOTE",
  INELIGIBLE = "INELIGIBLE",
  NEEDS_APPROVAL = "NEEDS_APPROVAL",
  DECLINED = "DECLINED",
  APPROVED = "APPROVED",
  PURCHASED_POLICY = "PURCHASED_POLICY",
  CANCELED = "CANCELED",
}

export enum ApplicationType {
  PLAINTIFF = "PLAINTIFF",
  DEFENSE = "DEFENSE",
}

export enum ApplyPolicy {
  BEFORE_RESOLVER = "BEFORE_RESOLVER",
  AFTER_RESOLVER = "AFTER_RESOLVER",
}

export type ArchiveApplicationInput = {
  id: Scalars["Int"];
};

export enum ClaimClosureStatus {
  PAID = "PAID",
  DENIED = "DENIED",
}

export type CreateOrUpdateAdminInput = {
  userId?: Maybe<Scalars["String"]>;
  firstName: Scalars["String"];
  lastName: Scalars["String"];
  email: Scalars["String"];
  isActive: Scalars["Boolean"];
  role: Role;
};

export type CreateOrUpdateAdminPayload = {
  __typename?: "CreateOrUpdateAdminPayload";
  user?: Maybe<GraphQLUser>;
  emailInUseError?: Maybe<Scalars["Boolean"]>;
};

export type GraphQLApplicant = {
  __typename?: "GraphQLApplicant";
  id: Scalars["Int"];
  fullName: Scalars["String"];
  firstName: Scalars["String"];
  lastName: Scalars["String"];
  companyName: Scalars["String"];
  mailingAddress1: Scalars["String"];
  mailingAddress2?: Maybe<Scalars["String"]>;
  city: Scalars["String"];
  state: Scalars["String"];
  zipCode: Scalars["String"];
  phoneNumber: Scalars["String"];
  phoneExtension?: Maybe<Scalars["String"]>;
  emailAddress: Scalars["String"];
};

export type GraphQLApplicationForAdmin = {
  __typename?: "GraphQLApplicationForAdmin";
  approverName?: Maybe<Scalars["String"]>;
  reviewReasonsHtml?: Maybe<Scalars["String"]>;
  id: Scalars["Int"];
  purchaseRecord?: Maybe<GraphQLPurchaseRecord>;
  paymentOptions?: Maybe<GraphQLPaymentOptions>;
  partner?: Maybe<GraphQLPartner>;
  lossPayee?: Maybe<GraphQLLossPayee>;
  claim?: Maybe<GraphQLClaim>;
  status: ApplicationStatus;
  adminApprovalKey?: Maybe<Scalars["String"]>;
  hasAdminApproval?: Maybe<Scalars["Boolean"]>;
  approvalNote?: Maybe<Scalars["String"]>;
  approvedOn?: Maybe<Scalars["Date"]>;
  basePremiumRate: Scalars["Decimal"];
  basePremiumRateOverride?: Maybe<Scalars["Decimal"]>;
  ideaLoanNumber?: Maybe<Scalars["String"]>;
  addLossPayeeLink: Scalars["String"];
  hasDiligentEffortForm: Scalars["Boolean"];
  adminAttachments: Array<AdminAttachment>;
  securityKey: Scalars["String"];
  applicant: GraphQLApplicant;
  case?: Maybe<GraphQLCase>;
  optionalCoverages?: Maybe<GraphQLOptionalCoverages>;
  eligibilitySurvey?: Maybe<GraphQLEligibilitySurvey>;
  eligibility?: Maybe<QuoteEligibility>;
  jurisdiction?: Maybe<Scalars["String"]>;
  hasComplaintDocument: Scalars["Boolean"];
  hasSurplusLinesDocument: Scalars["Boolean"];
  type: ApplicationType;
  dateStarted?: Maybe<Scalars["Date"]>;
  dateModified?: Maybe<Scalars["Date"]>;
  dateQuoteSaved?: Maybe<Scalars["Date"]>;
  quoteAvailableUntil?: Maybe<Scalars["Date"]>;
  reapplicationKey?: Maybe<Scalars["String"]>;
  shouldSendReminders: Scalars["Boolean"];
};

export type GraphQLApplicationForApplicant = {
  __typename?: "GraphQLApplicationForApplicant";
  securityKey: Scalars["String"];
  applicant: GraphQLApplicant;
  case?: Maybe<GraphQLCase>;
  optionalCoverages?: Maybe<GraphQLOptionalCoverages>;
  eligibilitySurvey?: Maybe<GraphQLEligibilitySurvey>;
  eligibility?: Maybe<QuoteEligibility>;
  jurisdiction?: Maybe<Scalars["String"]>;
  hasComplaintDocument: Scalars["Boolean"];
  hasSurplusLinesDocument: Scalars["Boolean"];
  type: ApplicationType;
  dateStarted?: Maybe<Scalars["Date"]>;
  dateModified?: Maybe<Scalars["Date"]>;
  dateQuoteSaved?: Maybe<Scalars["Date"]>;
  quoteAvailableUntil?: Maybe<Scalars["Date"]>;
  reapplicationKey?: Maybe<Scalars["String"]>;
  shouldSendReminders: Scalars["Boolean"];
};

export type GraphQLCase = {
  __typename?: "GraphQLCase";
  id: Scalars["Int"];
  caseName: Scalars["String"];
  caseTypes: Array<Scalars["String"]>;
  policyLimit: Scalars["Decimal"];
  dateServed?: Maybe<Scalars["Date"]>;
  federalCourtState?: Maybe<Scalars["String"]>;
  willEmailComplaintSeparately: Scalars["Boolean"];
  closedOn?: Maybe<Scalars["Date"]>;
  caseNumber?: Maybe<Scalars["String"]>;
  lastUpdatedByAdmin?: Maybe<AdminUser>;
};

export type GraphQLClaim = {
  __typename?: "GraphQLClaim";
  id: Scalars["Int"];
  contactName: Scalars["String"];
  contactEmail: Scalars["String"];
  claimAmount?: Maybe<Scalars["Decimal"]>;
  dateSubmitted: Scalars["Date"];
  closedOn?: Maybe<Scalars["Date"]>;
  payoutAmount?: Maybe<Scalars["Decimal"]>;
  payoutDate?: Maybe<Scalars["Date"]>;
  claimNumber?: Maybe<Scalars["String"]>;
  closureStatus?: Maybe<ClaimClosureStatus>;
  adverseJudgmentFiles: Array<AdverseJudgementFile>;
  insuredW9Files: Array<InsuredW9File>;
  litigationCostListingFiles: Array<LitigationCostListingFile>;
  proofOfPaymentFiles: Array<ProofOfPaymentFile>;
  litigationCostInvoicesFiles: Array<LitigationCostInvoicesFile>;
  lastUpdatedByAdmin?: Maybe<AdminUser>;
};

export type GraphQLEligibilitySurvey = {
  __typename?: "GraphQLEligibilitySurvey";
  id: Scalars["Int"];
  hasViolatedProcedureEleven: Scalars["Boolean"];
  hasApplicantBeenDisciplined: Scalars["Boolean"];
  hasRecentLcpClaim?: Maybe<Scalars["Boolean"]>;
  isDefendantTobaccoRelated?: Maybe<Scalars["Boolean"]>;
  isCaseCovidDamagesRelated: Scalars["Boolean"];
  affirmedNoDiscovery?: Maybe<Scalars["Boolean"]>;
};

export type GraphQLLossPayee = {
  __typename?: "GraphQLLossPayee";
  id: Scalars["Int"];
  name: Scalars["String"];
  mailingAddress1: Scalars["String"];
  mailingAddress2?: Maybe<Scalars["String"]>;
  city: Scalars["String"];
  state: Scalars["String"];
  zipCode: Scalars["String"];
  phoneNumber: Scalars["String"];
};

export type GraphQLOptionalCoverages = {
  __typename?: "GraphQLOptionalCoverages";
  id: Scalars["Int"];
  feeCoverageLimit?: Maybe<Scalars["Decimal"]>;
};

export type GraphQLPartner = {
  __typename?: "GraphQLPartner";
  id: Scalars["Int"];
  name: Scalars["String"];
  email: Scalars["String"];
  logoFilePath: Scalars["String"];
  allowedProgramTypes: Array<ApplicationType>;
};

export type GraphQLPartnerCommission = {
  __typename?: "GraphQLPartnerCommission";
  type: Scalars["String"];
  rate: Scalars["Decimal"];
  amount: Scalars["Decimal"];
};

export type GraphQLPaymentOptions = {
  __typename?: "GraphQLPaymentOptions";
  id: Scalars["Int"];
  isFinanced: Scalars["Boolean"];
};

export type GraphQLPurchaseRecord = {
  __typename?: "GraphQLPurchaseRecord";
  id: Scalars["Int"];
  policyNumber: Scalars["String"];
  basePremium: Scalars["Decimal"];
  feeCoveragePremium: Scalars["Decimal"];
  premium: Scalars["Decimal"];
  premiumTax: Scalars["Decimal"];
  stampingFeeLabel: Scalars["String"];
  stampingFee?: Maybe<Scalars["Decimal"]>;
  stateSpecificTaxOrFeeName?: Maybe<Scalars["String"]>;
  stateSpecificTaxOrFee?: Maybe<Scalars["Decimal"]>;
  policyFee: Scalars["Decimal"];
  policyFeeTax: Scalars["Decimal"];
  surplusLinesTax: Scalars["Decimal"];
  amountPaid: Scalars["Decimal"];
  datePurchased: Scalars["Date"];
  stripeFee?: Maybe<Scalars["Decimal"]>;
  netAmountPaid: Scalars["Decimal"];
  isSociusBill: Scalars["Boolean"];
  partnerCommission?: Maybe<GraphQLPartnerCommission>;
  levelCommissionRate: Scalars["Decimal"];
  levelCommission: Scalars["Decimal"];
  sociusCommissionRate: Scalars["Decimal"];
  sociusCommission: Scalars["Decimal"];
  totalCommissionRate: Scalars["Decimal"];
  totalCommission: Scalars["Decimal"];
  levelNetCommission: Scalars["Decimal"];
};

export type GraphQLUser = {
  __typename?: "GraphQLUser";
  roles: Array<Role>;
  id: Scalars["String"];
  firstName: Scalars["String"];
  lastName: Scalars["String"];
  email: Scalars["String"];
  isActive: Scalars["Boolean"];
  isDevAccount: Scalars["Boolean"];
};

export type InsuredW9File = {
  __typename?: "InsuredW9File";
  claimId: Scalars["Int"];
  fileStorageId: Scalars["Int"];
};

export type LitigationCostInvoicesFile = {
  __typename?: "LitigationCostInvoicesFile";
  claimId: Scalars["Int"];
  fileStorageId: Scalars["Int"];
};

export type LitigationCostListingFile = {
  __typename?: "LitigationCostListingFile";
  claimId: Scalars["Int"];
  fileStorageId: Scalars["Int"];
};

export type Mutation = {
  __typename?: "Mutation";
  archiveApplication: GraphQLApplicationForAdmin;
  createOrUpdateAdmin: CreateOrUpdateAdminPayload;
  removeAdminAttachment: RemoveAdminAttachmentPayload;
  submitAdminApproval?: Maybe<QuoteViewModel>;
  updateAppShouldSendReminders: GraphQLApplicationForAdmin;
  updateCaseNumber: GraphQLApplicationForAdmin;
  updateCaseStatus: GraphQLApplicationForAdmin;
  updateClaimStatus: GraphQLApplicationForAdmin;
  updateIdeaLoanNumber: GraphQLApplicationForAdmin;
};

export type MutationArchiveApplicationArgs = {
  input: ArchiveApplicationInput;
};

export type MutationCreateOrUpdateAdminArgs = {
  input: CreateOrUpdateAdminInput;
};

export type MutationRemoveAdminAttachmentArgs = {
  input: RemoveAdminAttachmentInput;
};

export type MutationSubmitAdminApprovalArgs = {
  input: SubmitAdminApprovalInput;
};

export type MutationUpdateAppShouldSendRemindersArgs = {
  input: UpdateAppShouldSendRemindersInput;
};

export type MutationUpdateCaseNumberArgs = {
  input: UpdateCaseNumberInput;
};

export type MutationUpdateCaseStatusArgs = {
  input: UpdateCaseStatusInput;
};

export type MutationUpdateClaimStatusArgs = {
  input: UpdateClaimStatusInput;
};

export type MutationUpdateIdeaLoanNumberArgs = {
  input: UpdateIdeaLoanNumberInput;
};

export type ProofOfPaymentFile = {
  __typename?: "ProofOfPaymentFile";
  claimId: Scalars["Int"];
  fileStorageId: Scalars["Int"];
};

export type Query = {
  __typename?: "Query";
  adminApprovalQuote?: Maybe<QuoteViewModel>;
  adminAttachments: Array<AdminAttachment>;
  adminUsers: Array<GraphQLUser>;
  application?: Maybe<GraphQLApplicationForAdmin>;
  applicationByKey?: Maybe<GraphQLApplicationForApplicant>;
  approvalRequiredApplications: Array<GraphQLApplicationForAdmin>;
  partner?: Maybe<GraphQLPartner>;
  partners: Array<GraphQLPartner>;
  user?: Maybe<GraphQLUser>;
  searchApplications: SearchApplicationsQueryPayload;
};

export type QueryAdminApprovalQuoteArgs = {
  adminApprovalKey: Scalars["String"];
  basePremiumRateOverride?: Maybe<Scalars["Decimal"]>;
};

export type QueryAdminAttachmentsArgs = {
  appId?: Maybe<Scalars["Int"]>;
  adminApprovalKey?: Maybe<Scalars["String"]>;
};

export type QueryApplicationArgs = {
  id: Scalars["Int"];
};

export type QueryApplicationByKeyArgs = {
  securityKey: Scalars["String"];
};

export type QueryApprovalRequiredApplicationsArgs = {
  touchedAfter: Scalars["Date"];
};

export type QueryPartnerArgs = {
  key: Scalars["String"];
};

export type QuerySearchApplicationsArgs = {
  input: SearchApplicationsQueryInput;
};

export enum QuoteEligibility {
  INELIGIBLE = "INELIGIBLE",
  NEEDS_APPROVAL = "NEEDS_APPROVAL",
  ELIGIBLE = "ELIGIBLE",
}

export type QuoteViewModel = {
  __typename?: "QuoteViewModel";
  applicationId: Scalars["Int"];
  applicantName: Scalars["String"];
  applicantEmail: Scalars["String"];
  jurisdiction: Scalars["String"];
  federalCourtState?: Maybe<Scalars["String"]>;
  companyName: Scalars["String"];
  coverageState: Scalars["String"];
  caseName: Scalars["String"];
  policyLimit: Scalars["Decimal"];
  feeCoverageLimit?: Maybe<Scalars["Decimal"]>;
  dateOfService?: Maybe<Scalars["Date"]>;
  hasAdminApproval?: Maybe<Scalars["Boolean"]>;
  needsAdminApproval: Scalars["Boolean"];
  downPayment?: Maybe<Scalars["Decimal"]>;
  basePremium: Scalars["Decimal"];
  basePremiumRate: Scalars["Decimal"];
  feeCoveragePremium?: Maybe<Scalars["Decimal"]>;
  premium: Scalars["Decimal"];
  premiumTax?: Maybe<Scalars["Decimal"]>;
  stampingFee?: Maybe<Scalars["Decimal"]>;
  stampingFeeLabel: Scalars["String"];
  stateSpecificTaxOrFee?: Maybe<Scalars["Decimal"]>;
  stateSpecificTaxOrFeeName?: Maybe<Scalars["String"]>;
  policyFee: Scalars["Decimal"];
  policyFeeTax: Scalars["Decimal"];
  totalPaymentAmount: Scalars["Decimal"];
  fullQuotedAmount: Scalars["Decimal"];
  totalFees: Scalars["Decimal"];
  surplusLinesTax: Scalars["Decimal"];
  hasChangedSinceLastViewed: Scalars["Boolean"];
  appType: ApplicationType;
  partnerName?: Maybe<Scalars["String"]>;
};

export type RemoveAdminAttachmentInput = {
  attachmentId: Scalars["Int"];
};

export type RemoveAdminAttachmentPayload = {
  __typename?: "RemoveAdminAttachmentPayload";
  attachmentId: Scalars["Int"];
};

export enum Role {
  ADMIN = "ADMIN",
  SUPER_ADMIN = "SUPER_ADMIN",
}

export type SearchApplicationsQueryInput = {
  searchText: Scalars["String"];
  page?: Maybe<Scalars["Int"]>;
  resultsPerPage: Scalars["Int"];
};

export type SearchApplicationsQueryPayload = {
  __typename?: "SearchApplicationsQueryPayload";
  applications: Array<GraphQLApplicationForAdmin>;
  totalCount: Scalars["Int"];
};

export type SubmitAdminApprovalInput = {
  adminApprovalKey: Scalars["String"];
  hasAdminApproval: Scalars["Boolean"];
  shouldSendDenyEmail: Scalars["Boolean"];
  basePremiumRateOverride?: Maybe<Scalars["Decimal"]>;
  note?: Maybe<Scalars["String"]>;
};

export type UpdateAppShouldSendRemindersInput = {
  securityKey: Scalars["String"];
  shouldSendReminders: Scalars["Boolean"];
};

export type UpdateCaseNumberInput = {
  securityKey: Scalars["String"];
  caseNumber?: Maybe<Scalars["String"]>;
};

export type UpdateCaseStatusInput = {
  securityKey: Scalars["String"];
  closedOn: Scalars["Date"];
};

export type UpdateClaimStatusInput = {
  securityKey: Scalars["String"];
  closureStatus: ClaimClosureStatus;
  closedOn: Scalars["Date"];
  payoutAmount?: Maybe<Scalars["Decimal"]>;
  payoutDate?: Maybe<Scalars["Date"]>;
  claimNumber?: Maybe<Scalars["String"]>;
};

export type UpdateIdeaLoanNumberInput = {
  securityKey: Scalars["String"];
  ideaLoanNumber?: Maybe<Scalars["String"]>;
};

export type ApprovalRequiredApplicationsQueryVariables = Exact<{
  touchedAfter: Scalars["Date"];
}>;

export type ApprovalRequiredApplicationsQuery = { __typename?: "Query" } & {
  approvalRequiredApplications: Array<
    { __typename?: "GraphQLApplicationForAdmin" } & ApplicationFragment
  >;
};

export type PartnersQueryVariables = Exact<{ [key: string]: never }>;

export type PartnersQuery = { __typename?: "Query" } & {
  partners: Array<
    { __typename?: "GraphQLPartner" } & Pick<GraphQLPartner, "id" | "name">
  >;
};

export type ArchiveApplicationMutationVariables = Exact<{
  input: ArchiveApplicationInput;
}>;

export type ArchiveApplicationMutation = { __typename?: "Mutation" } & {
  archiveApplication: {
    __typename?: "GraphQLApplicationForAdmin";
  } & ApplicationFragment;
};

export type UpdateAppShouldSendRemindersMutationVariables = Exact<{
  input: UpdateAppShouldSendRemindersInput;
}>;

export type UpdateAppShouldSendRemindersMutation = {
  __typename?: "Mutation";
} & {
  updateAppShouldSendReminders: {
    __typename?: "GraphQLApplicationForAdmin";
  } & ApplicationFragment;
};

export type UpdateCaseNumberMutationVariables = Exact<{
  input: UpdateCaseNumberInput;
}>;

export type UpdateCaseNumberMutation = { __typename?: "Mutation" } & {
  updateCaseNumber: {
    __typename?: "GraphQLApplicationForAdmin";
  } & ApplicationFragment;
};

export type UpdateCaseStatusMutationVariables = Exact<{
  input: UpdateCaseStatusInput;
}>;

export type UpdateCaseStatusMutation = { __typename?: "Mutation" } & {
  updateCaseStatus: {
    __typename?: "GraphQLApplicationForAdmin";
  } & ApplicationFragment;
};

export type UpdateClaimStatusMutationVariables = Exact<{
  input: UpdateClaimStatusInput;
}>;

export type UpdateClaimStatusMutation = { __typename?: "Mutation" } & {
  updateClaimStatus: {
    __typename?: "GraphQLApplicationForAdmin";
  } & ApplicationFragment;
};

export type UpdateIdeaLoanNumberMutationVariables = Exact<{
  input: UpdateIdeaLoanNumberInput;
}>;

export type UpdateIdeaLoanNumberMutation = { __typename?: "Mutation" } & {
  updateIdeaLoanNumber: {
    __typename?: "GraphQLApplicationForAdmin";
  } & ApplicationFragment;
};

export type ApplicationByKeyQueryVariables = Exact<{
  securityKey: Scalars["String"];
}>;

export type ApplicationByKeyQuery = { __typename?: "Query" } & {
  applicationByKey?: Maybe<
    { __typename?: "GraphQLApplicationForApplicant" } & Pick<
      GraphQLApplicationForApplicant,
      | "securityKey"
      | "jurisdiction"
      | "hasComplaintDocument"
      | "hasSurplusLinesDocument"
      | "type"
      | "dateStarted"
      | "dateModified"
      | "dateQuoteSaved"
      | "quoteAvailableUntil"
      | "reapplicationKey"
    > & {
        applicant: { __typename?: "GraphQLApplicant" } & Pick<
          GraphQLApplicant,
          | "id"
          | "fullName"
          | "companyName"
          | "mailingAddress1"
          | "mailingAddress2"
          | "city"
          | "state"
          | "zipCode"
          | "phoneNumber"
          | "phoneExtension"
          | "emailAddress"
        >;
        case?: Maybe<
          { __typename?: "GraphQLCase" } & Pick<
            GraphQLCase,
            | "id"
            | "caseName"
            | "caseTypes"
            | "policyLimit"
            | "dateServed"
            | "federalCourtState"
            | "willEmailComplaintSeparately"
          >
        >;
        optionalCoverages?: Maybe<
          { __typename?: "GraphQLOptionalCoverages" } & Pick<
            GraphQLOptionalCoverages,
            "id" | "feeCoverageLimit"
          >
        >;
        eligibilitySurvey?: Maybe<
          { __typename?: "GraphQLEligibilitySurvey" } & Pick<
            GraphQLEligibilitySurvey,
            | "id"
            | "hasViolatedProcedureEleven"
            | "hasApplicantBeenDisciplined"
            | "isCaseCovidDamagesRelated"
            | "affirmedNoDiscovery"
          >
        >;
      }
  >;
};

export type AdminUsersQueryVariables = Exact<{ [key: string]: never }>;

export type AdminUsersQuery = { __typename?: "Query" } & {
  adminUsers: Array<{ __typename?: "GraphQLUser" } & AdminUserFragment>;
};

export type CreateOrUpdateAdminMutationVariables = Exact<{
  input: CreateOrUpdateAdminInput;
}>;

export type CreateOrUpdateAdminMutation = { __typename?: "Mutation" } & {
  createOrUpdateAdmin: { __typename?: "CreateOrUpdateAdminPayload" } & Pick<
    CreateOrUpdateAdminPayload,
    "emailInUseError"
  > & { user?: Maybe<{ __typename?: "GraphQLUser" } & AdminUserFragment> };
};

export type AdminApplicationQueryVariables = Exact<{
  id: Scalars["Int"];
}>;

export type AdminApplicationQuery = { __typename?: "Query" } & {
  application?: Maybe<
    { __typename?: "GraphQLApplicationForAdmin" } & ApplicationFragment
  >;
  adminAttachments: Array<
    { __typename?: "AdminAttachment" } & Pick<
      AdminAttachment,
      "id" | "filename"
    >
  >;
};

export type AdminApprovalQuoteQueryVariables = Exact<{
  adminApprovalKey: Scalars["String"];
  basePremiumRateOverride?: Maybe<Scalars["Decimal"]>;
}>;

export type AdminApprovalQuoteQuery = { __typename?: "Query" } & {
  adminApprovalQuote?: Maybe<
    { __typename?: "QuoteViewModel" } & Pick<
      QuoteViewModel,
      | "applicationId"
      | "applicantName"
      | "applicantEmail"
      | "appType"
      | "basePremium"
      | "basePremiumRate"
      | "caseName"
      | "companyName"
      | "coverageState"
      | "dateOfService"
      | "downPayment"
      | "federalCourtState"
      | "feeCoverageLimit"
      | "feeCoveragePremium"
      | "needsAdminApproval"
      | "hasAdminApproval"
      | "hasChangedSinceLastViewed"
      | "jurisdiction"
      | "policyFee"
      | "policyFeeTax"
      | "policyLimit"
      | "premium"
      | "premiumTax"
      | "surplusLinesTax"
      | "stampingFee"
      | "stampingFeeLabel"
      | "stateSpecificTaxOrFee"
      | "stateSpecificTaxOrFeeName"
      | "totalFees"
      | "totalPaymentAmount"
    >
  >;
  adminAttachments: Array<
    { __typename?: "AdminAttachment" } & Pick<
      AdminAttachment,
      "id" | "filename"
    >
  >;
};

export type AdminUserFragment = { __typename?: "GraphQLUser" } & Pick<
  GraphQLUser,
  | "id"
  | "firstName"
  | "lastName"
  | "email"
  | "isActive"
  | "isDevAccount"
  | "roles"
>;

export type ApplicationFragment = {
  __typename?: "GraphQLApplicationForAdmin";
} & Pick<
  GraphQLApplicationForAdmin,
  | "id"
  | "securityKey"
  | "eligibility"
  | "status"
  | "jurisdiction"
  | "adminApprovalKey"
  | "hasAdminApproval"
  | "approvalNote"
  | "approvedOn"
  | "approverName"
  | "basePremiumRate"
  | "basePremiumRateOverride"
  | "hasComplaintDocument"
  | "hasSurplusLinesDocument"
  | "hasDiligentEffortForm"
  | "type"
  | "dateStarted"
  | "dateModified"
  | "dateQuoteSaved"
  | "quoteAvailableUntil"
  | "shouldSendReminders"
  | "addLossPayeeLink"
  | "ideaLoanNumber"
  | "reviewReasonsHtml"
> & {
    applicant: { __typename?: "GraphQLApplicant" } & Pick<
      GraphQLApplicant,
      | "id"
      | "fullName"
      | "companyName"
      | "mailingAddress1"
      | "mailingAddress2"
      | "city"
      | "state"
      | "zipCode"
      | "phoneNumber"
      | "phoneExtension"
      | "emailAddress"
    >;
    lossPayee?: Maybe<
      { __typename?: "GraphQLLossPayee" } & Pick<
        GraphQLLossPayee,
        | "id"
        | "name"
        | "mailingAddress1"
        | "mailingAddress2"
        | "city"
        | "state"
        | "zipCode"
        | "phoneNumber"
      >
    >;
    case?: Maybe<
      { __typename?: "GraphQLCase" } & Pick<
        GraphQLCase,
        | "id"
        | "caseName"
        | "caseNumber"
        | "caseTypes"
        | "policyLimit"
        | "dateServed"
        | "federalCourtState"
        | "willEmailComplaintSeparately"
        | "closedOn"
      > & {
          lastUpdatedByAdmin?: Maybe<
            { __typename?: "AdminUser" } & Pick<AdminUser, "id" | "fullName">
          >;
        }
    >;
    optionalCoverages?: Maybe<
      { __typename?: "GraphQLOptionalCoverages" } & Pick<
        GraphQLOptionalCoverages,
        "id" | "feeCoverageLimit"
      >
    >;
    eligibilitySurvey?: Maybe<
      { __typename?: "GraphQLEligibilitySurvey" } & Pick<
        GraphQLEligibilitySurvey,
        | "id"
        | "hasViolatedProcedureEleven"
        | "hasApplicantBeenDisciplined"
        | "hasRecentLcpClaim"
        | "isDefendantTobaccoRelated"
        | "isCaseCovidDamagesRelated"
        | "affirmedNoDiscovery"
      >
    >;
    purchaseRecord?: Maybe<
      { __typename?: "GraphQLPurchaseRecord" } & Pick<
        GraphQLPurchaseRecord,
        | "id"
        | "policyNumber"
        | "basePremium"
        | "feeCoveragePremium"
        | "premium"
        | "premiumTax"
        | "stampingFeeLabel"
        | "stampingFee"
        | "stateSpecificTaxOrFeeName"
        | "stateSpecificTaxOrFee"
        | "policyFee"
        | "policyFeeTax"
        | "surplusLinesTax"
        | "amountPaid"
        | "datePurchased"
        | "stripeFee"
        | "netAmountPaid"
        | "isSociusBill"
        | "levelCommissionRate"
        | "levelCommission"
        | "sociusCommissionRate"
        | "sociusCommission"
        | "totalCommissionRate"
        | "totalCommission"
        | "levelNetCommission"
      > & {
          partnerCommission?: Maybe<
            { __typename?: "GraphQLPartnerCommission" } & Pick<
              GraphQLPartnerCommission,
              "type" | "rate" | "amount"
            >
          >;
        }
    >;
    paymentOptions?: Maybe<
      { __typename?: "GraphQLPaymentOptions" } & Pick<
        GraphQLPaymentOptions,
        "id" | "isFinanced"
      >
    >;
    partner?: Maybe<
      { __typename?: "GraphQLPartner" } & Pick<GraphQLPartner, "id" | "name">
    >;
    claim?: Maybe<
      { __typename?: "GraphQLClaim" } & Pick<
        GraphQLClaim,
        | "id"
        | "contactName"
        | "contactEmail"
        | "claimAmount"
        | "dateSubmitted"
        | "closedOn"
        | "closureStatus"
        | "payoutAmount"
        | "payoutDate"
        | "claimNumber"
      > & {
          adverseJudgmentFiles: Array<
            { __typename?: "AdverseJudgementFile" } & Pick<
              AdverseJudgementFile,
              "fileStorageId"
            >
          >;
          insuredW9Files: Array<
            { __typename?: "InsuredW9File" } & Pick<
              InsuredW9File,
              "fileStorageId"
            >
          >;
          litigationCostListingFiles: Array<
            { __typename?: "LitigationCostListingFile" } & Pick<
              LitigationCostListingFile,
              "fileStorageId"
            >
          >;
          proofOfPaymentFiles: Array<
            { __typename?: "ProofOfPaymentFile" } & Pick<
              ProofOfPaymentFile,
              "fileStorageId"
            >
          >;
          litigationCostInvoicesFiles: Array<
            { __typename?: "LitigationCostInvoicesFile" } & Pick<
              LitigationCostInvoicesFile,
              "fileStorageId"
            >
          >;
          lastUpdatedByAdmin?: Maybe<
            { __typename?: "AdminUser" } & Pick<AdminUser, "id" | "fullName">
          >;
        }
    >;
  };

export type ApplicationQueryVariables = Exact<{
  id: Scalars["Int"];
}>;

export type ApplicationQuery = { __typename?: "Query" } & {
  application?: Maybe<
    { __typename?: "GraphQLApplicationForAdmin" } & ApplicationFragment
  >;
};

export type PartnerQueryVariables = Exact<{
  key: Scalars["String"];
}>;

export type PartnerQuery = { __typename?: "Query" } & {
  partner?: Maybe<
    { __typename?: "GraphQLPartner" } & Pick<
      GraphQLPartner,
      "id" | "name" | "logoFilePath" | "allowedProgramTypes"
    >
  >;
};

export type RemoveAdminAttachmentMutationVariables = Exact<{
  input: RemoveAdminAttachmentInput;
}>;

export type RemoveAdminAttachmentMutation = { __typename?: "Mutation" } & {
  removeAdminAttachment: { __typename?: "RemoveAdminAttachmentPayload" } & Pick<
    RemoveAdminAttachmentPayload,
    "attachmentId"
  >;
};

export type SearchApplicationsQueryVariables = Exact<{
  input: SearchApplicationsQueryInput;
}>;

export type SearchApplicationsQuery = { __typename?: "Query" } & {
  searchApplications: { __typename?: "SearchApplicationsQueryPayload" } & Pick<
    SearchApplicationsQueryPayload,
    "totalCount"
  > & {
      applications: Array<
        { __typename?: "GraphQLApplicationForAdmin" } & Pick<
          GraphQLApplicationForAdmin,
          "id" | "type" | "dateModified" | "status"
        > & {
            applicant: { __typename?: "GraphQLApplicant" } & Pick<
              GraphQLApplicant,
              | "id"
              | "fullName"
              | "companyName"
              | "phoneNumber"
              | "phoneExtension"
              | "emailAddress"
            >;
            case?: Maybe<
              { __typename?: "GraphQLCase" } & Pick<
                GraphQLCase,
                "id" | "caseName" | "dateServed" | "policyLimit" | "closedOn"
              >
            >;
            purchaseRecord?: Maybe<
              { __typename?: "GraphQLPurchaseRecord" } & Pick<
                GraphQLPurchaseRecord,
                "id" | "policyNumber" | "datePurchased"
              >
            >;
            claim?: Maybe<
              { __typename?: "GraphQLClaim" } & Pick<
                GraphQLClaim,
                "closedOn" | "closureStatus"
              >
            >;
          }
      >;
    };
};

export type SubmitAdminApprovalMutationVariables = Exact<{
  input: SubmitAdminApprovalInput;
}>;

export type SubmitAdminApprovalMutation = { __typename?: "Mutation" } & {
  submitAdminApproval?: Maybe<
    { __typename?: "QuoteViewModel" } & Pick<QuoteViewModel, "hasAdminApproval">
  >;
};

export type UserQueryVariables = Exact<{ [key: string]: never }>;

export type UserQuery = { __typename?: "Query" } & {
  user?: Maybe<
    { __typename?: "GraphQLUser" } & Pick<
      GraphQLUser,
      "id" | "firstName" | "lastName" | "email" | "roles" | "isActive"
    >
  >;
};

export const adminUserFragmentDoc = gql`
  fragment adminUserFragment on GraphQLUser {
    id
    firstName
    lastName
    email
    isActive
    isDevAccount
    roles
  }
` as unknown as DocumentNode<AdminUserFragment, unknown>;
export const applicationFragmentDoc = gql`
  fragment applicationFragment on GraphQLApplicationForAdmin {
    id
    securityKey
    applicant {
      id
      fullName
      companyName
      mailingAddress1
      mailingAddress2
      city
      state
      zipCode
      phoneNumber
      phoneExtension
      emailAddress
    }
    lossPayee {
      id
      name
      mailingAddress1
      mailingAddress2
      city
      state
      zipCode
      phoneNumber
    }
    case {
      id
      caseName
      caseNumber
      caseTypes
      policyLimit
      dateServed
      federalCourtState
      willEmailComplaintSeparately
      closedOn
      lastUpdatedByAdmin {
        id
        fullName
      }
    }
    optionalCoverages {
      id
      feeCoverageLimit
    }
    eligibility
    eligibilitySurvey {
      id
      hasViolatedProcedureEleven
      hasApplicantBeenDisciplined
      hasRecentLcpClaim
      isDefendantTobaccoRelated
      isCaseCovidDamagesRelated
      affirmedNoDiscovery
    }
    purchaseRecord {
      id
      policyNumber
      basePremium
      feeCoveragePremium
      premium
      premiumTax
      stampingFeeLabel
      stampingFee
      stateSpecificTaxOrFeeName
      stateSpecificTaxOrFee
      policyFee
      policyFeeTax
      surplusLinesTax
      amountPaid
      datePurchased
      stripeFee
      netAmountPaid
      isSociusBill
      partnerCommission {
        type
        rate
        amount
      }
      levelCommissionRate
      levelCommission
      sociusCommissionRate
      sociusCommission
      totalCommissionRate
      totalCommission
      levelNetCommission
    }
    paymentOptions {
      id
      isFinanced
    }
    partner {
      id
      name
    }
    claim {
      id
      contactName
      contactEmail
      claimAmount
      dateSubmitted
      closedOn
      closureStatus
      payoutAmount
      payoutDate
      claimNumber
      adverseJudgmentFiles {
        fileStorageId
      }
      insuredW9Files {
        fileStorageId
      }
      litigationCostListingFiles {
        fileStorageId
      }
      proofOfPaymentFiles {
        fileStorageId
      }
      litigationCostInvoicesFiles {
        fileStorageId
      }
      lastUpdatedByAdmin {
        id
        fullName
      }
    }
    status
    jurisdiction
    adminApprovalKey
    hasAdminApproval
    approvalNote
    approvedOn
    approverName
    basePremiumRate
    basePremiumRateOverride
    hasComplaintDocument
    hasSurplusLinesDocument
    hasDiligentEffortForm
    type
    dateStarted
    dateModified
    dateQuoteSaved
    quoteAvailableUntil
    shouldSendReminders
    addLossPayeeLink
    ideaLoanNumber
    reviewReasonsHtml
  }
` as unknown as DocumentNode<ApplicationFragment, unknown>;
export const approvalRequiredApplicationsQuery = gql`
  query ApprovalRequiredApplicationsQuery($touchedAfter: Date!) {
    approvalRequiredApplications(touchedAfter: $touchedAfter) {
      ...applicationFragment
    }
  }
  ${applicationFragmentDoc}
` as unknown as DocumentNode<
  ApprovalRequiredApplicationsQuery,
  ApprovalRequiredApplicationsQueryVariables
>;
export const partnersQuery = gql`
  query PartnersQuery {
    partners {
      id
      name
    }
  }
` as unknown as DocumentNode<PartnersQuery, PartnersQueryVariables>;
export const archiveApplicationMutation = gql`
  mutation ArchiveApplicationMutation($input: ArchiveApplicationInput!) {
    archiveApplication(input: $input) {
      ...applicationFragment
    }
  }
  ${applicationFragmentDoc}
` as unknown as DocumentNode<
  ArchiveApplicationMutation,
  ArchiveApplicationMutationVariables
>;
export const updateAppShouldSendReminders = gql`
  mutation UpdateAppShouldSendReminders(
    $input: UpdateAppShouldSendRemindersInput!
  ) {
    updateAppShouldSendReminders(input: $input) {
      ...applicationFragment
    }
  }
  ${applicationFragmentDoc}
` as unknown as DocumentNode<
  UpdateAppShouldSendRemindersMutation,
  UpdateAppShouldSendRemindersMutationVariables
>;
export const updateCaseNumberMutation = gql`
  mutation UpdateCaseNumberMutation($input: UpdateCaseNumberInput!) {
    updateCaseNumber(input: $input) {
      ...applicationFragment
    }
  }
  ${applicationFragmentDoc}
` as unknown as DocumentNode<
  UpdateCaseNumberMutation,
  UpdateCaseNumberMutationVariables
>;
export const updateCaseStatusMutation = gql`
  mutation UpdateCaseStatusMutation($input: UpdateCaseStatusInput!) {
    updateCaseStatus(input: $input) {
      ...applicationFragment
    }
  }
  ${applicationFragmentDoc}
` as unknown as DocumentNode<
  UpdateCaseStatusMutation,
  UpdateCaseStatusMutationVariables
>;
export const updateClaimStatusMutation = gql`
  mutation UpdateClaimStatusMutation($input: UpdateClaimStatusInput!) {
    updateClaimStatus(input: $input) {
      ...applicationFragment
    }
  }
  ${applicationFragmentDoc}
` as unknown as DocumentNode<
  UpdateClaimStatusMutation,
  UpdateClaimStatusMutationVariables
>;
export const updateIdeaLoanNumberMutation = gql`
  mutation UpdateIdeaLoanNumberMutation($input: UpdateIdeaLoanNumberInput!) {
    updateIdeaLoanNumber(input: $input) {
      ...applicationFragment
    }
  }
  ${applicationFragmentDoc}
` as unknown as DocumentNode<
  UpdateIdeaLoanNumberMutation,
  UpdateIdeaLoanNumberMutationVariables
>;
export const applicationByKeyQuery = gql`
  query ApplicationByKeyQuery($securityKey: String!) {
    applicationByKey(securityKey: $securityKey) {
      securityKey
      applicant {
        id
        fullName
        companyName
        mailingAddress1
        mailingAddress2
        city
        state
        zipCode
        phoneNumber
        phoneExtension
        emailAddress
      }
      case {
        id
        caseName
        caseTypes
        policyLimit
        dateServed
        federalCourtState
        willEmailComplaintSeparately
      }
      optionalCoverages {
        id
        feeCoverageLimit
      }
      eligibilitySurvey {
        id
        hasViolatedProcedureEleven
        hasApplicantBeenDisciplined
        isCaseCovidDamagesRelated
        affirmedNoDiscovery
      }
      jurisdiction
      hasComplaintDocument
      hasSurplusLinesDocument
      type
      dateStarted
      dateModified
      dateQuoteSaved
      quoteAvailableUntil
      reapplicationKey
    }
  }
` as unknown as DocumentNode<
  ApplicationByKeyQuery,
  ApplicationByKeyQueryVariables
>;
export const adminUsersQuery = gql`
  query AdminUsersQuery {
    adminUsers {
      ...adminUserFragment
    }
  }
  ${adminUserFragmentDoc}
` as unknown as DocumentNode<AdminUsersQuery, AdminUsersQueryVariables>;
export const createOrUpdateAdminMutation = gql`
  mutation CreateOrUpdateAdminMutation($input: CreateOrUpdateAdminInput!) {
    createOrUpdateAdmin(input: $input) {
      user {
        ...adminUserFragment
      }
      emailInUseError
    }
  }
  ${adminUserFragmentDoc}
` as unknown as DocumentNode<
  CreateOrUpdateAdminMutation,
  CreateOrUpdateAdminMutationVariables
>;
export const adminApplicationQuery = gql`
  query AdminApplicationQuery($id: Int!) {
    application(id: $id) {
      ...applicationFragment
    }
    adminAttachments(appId: $id) {
      id
      filename
    }
  }
  ${applicationFragmentDoc}
` as unknown as DocumentNode<
  AdminApplicationQuery,
  AdminApplicationQueryVariables
>;
export const adminApprovalQuoteQuery = gql`
  query AdminApprovalQuoteQuery(
    $adminApprovalKey: String!
    $basePremiumRateOverride: Decimal
  ) {
    adminApprovalQuote(
      adminApprovalKey: $adminApprovalKey
      basePremiumRateOverride: $basePremiumRateOverride
    ) {
      applicationId
      applicantName
      applicantEmail
      appType
      basePremium
      basePremiumRate
      caseName
      companyName
      coverageState
      dateOfService
      downPayment
      federalCourtState
      feeCoverageLimit
      feeCoveragePremium
      needsAdminApproval
      hasAdminApproval
      hasChangedSinceLastViewed
      jurisdiction
      policyFee
      policyFeeTax
      policyLimit
      premium
      premiumTax
      surplusLinesTax
      stampingFee
      stampingFeeLabel
      stateSpecificTaxOrFee
      stateSpecificTaxOrFeeName
      totalFees
      totalPaymentAmount
    }
    adminAttachments(adminApprovalKey: $adminApprovalKey) {
      id
      filename
    }
  }
` as unknown as DocumentNode<
  AdminApprovalQuoteQuery,
  AdminApprovalQuoteQueryVariables
>;
export const applicationQuery = gql`
  query ApplicationQuery($id: Int!) {
    application(id: $id) {
      ...applicationFragment
    }
  }
  ${applicationFragmentDoc}
` as unknown as DocumentNode<ApplicationQuery, ApplicationQueryVariables>;
export const partnerQuery = gql`
  query PartnerQuery($key: String!) {
    partner(key: $key) {
      id
      name
      logoFilePath
      allowedProgramTypes
    }
  }
` as unknown as DocumentNode<PartnerQuery, PartnerQueryVariables>;
export const removeAdminAttachmentMutation = gql`
  mutation RemoveAdminAttachmentMutation($input: RemoveAdminAttachmentInput!) {
    removeAdminAttachment(input: $input) {
      attachmentId
    }
  }
` as unknown as DocumentNode<
  RemoveAdminAttachmentMutation,
  RemoveAdminAttachmentMutationVariables
>;
export const searchApplicationsQuery = gql`
  query SearchApplicationsQuery($input: SearchApplicationsQueryInput!) {
    searchApplications(input: $input) {
      applications {
        id
        type
        dateModified
        status
        applicant {
          id
          fullName
          companyName
          phoneNumber
          phoneExtension
          emailAddress
        }
        case {
          id
          caseName
          dateServed
          policyLimit
          closedOn
        }
        purchaseRecord {
          id
          policyNumber
          datePurchased
        }
        claim {
          closedOn
          closureStatus
        }
      }
      totalCount
    }
  }
` as unknown as DocumentNode<
  SearchApplicationsQuery,
  SearchApplicationsQueryVariables
>;
export const submitAdminApprovalMutation = gql`
  mutation SubmitAdminApprovalMutation($input: SubmitAdminApprovalInput!) {
    submitAdminApproval(input: $input) {
      hasAdminApproval
    }
  }
` as unknown as DocumentNode<
  SubmitAdminApprovalMutation,
  SubmitAdminApprovalMutationVariables
>;
export const userQuery = gql`
  query UserQuery {
    user {
      id
      firstName
      lastName
      email
      roles
      isActive
    }
  }
` as unknown as DocumentNode<UserQuery, UserQueryVariables>;
